
module.exports={
 
  getUser: function(){
      const user =localStorage.getItem('email')
       if(user ==='undefined'|| !user){
           return null
       }else{
           return user 
       }
  },

  getToken: function(){
      return localStorage.getItem('token')
  },

  setUserSession: function(user,token){
      localStorage.setItem('email',user)
      localStorage.setItem('token',token)
     

 
    },

    resetUserSession : function(){
        localStorage.clear();
        window.location.href = `${process.env.REACT_APP_BASE_URL}login`;
    }
}